import { useCallback, useEffect, useRef, useState } from "react";
import { ReactComponent as Arrow } from "../../assets/langs/Arrow.svg";
import classNames from "classnames";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import GlobalState from "../../stores/GlobalState";
import { useLocation } from "react-router-dom";
import "./index.scss";
const LangSelect = () => {
  const ref = useRef<HTMLDivElement | null>(null);
  const listRef = useRef<HTMLDivElement | null>(null);
  const { pathname: asPath } = useLocation();
  const [state, setState] = useState("");
  const [open, setOpen] = useState(false);
  const [list, setList] = useState<Array<any>>([]);
  useOnClickOutside(ref, () => setOpen(false));

  useEffect(() => {
    const current = GlobalState.currentLocale.lang.includes("En")
      ? "en"
      : GlobalState.currentLocale.lang.includes("ру")
      ? "ru"
      : "ua";

    setState(current);

    const list = ["en", "ua"].filter((c) => c != current);
    setList(list);
  }, [asPath, GlobalState.currentLocale.lang]);

  const changeLocale = useCallback(
    (chosenLocale: string) => {
      if (chosenLocale == "ua") {
        window.location.href = window.location.href
          .replaceAll("/en/", "/")
          .replaceAll("/ru/", "/")
          .replaceAll("/uk/", "/");
      } else {
        const path = window.location.pathname
          .replaceAll("/en/", "/")
          .replaceAll("/ru/", "/")
          .replaceAll("/uk/", "/");

        window.location.href = `/${chosenLocale}${path}`;
      }
    },
    [asPath, state]
  );

  useEffect(() => {
    if (!ref.current || !listRef.current) return;
    ref.current?.style.setProperty(
      "--parent-height",
      ref.current.getBoundingClientRect().height + "px"
    );
    ref.current?.style.setProperty(
      "--list-height",
      listRef.current.getBoundingClientRect().height + "px"
    );
  });

  return (
    <div className={classNames("lang-toggle", open && "active-list")} ref={ref}>
      <div className="lang-toggle__top" onClick={() => setOpen(true)}>
        <span>{state.toUpperCase()}</span> <Arrow />
      </div>
      <div className="lang-toggle__list" ref={listRef}>
        {list
          ?.filter((c) => c != state)
          .map((ci: string, i: number) => (
            <div
              className="lang-toggle__item"
              key={i}
              onClick={() => changeLocale(ci)}
            >
              <span>{ci?.toUpperCase()}</span>
            </div>
          ))}
      </div>
    </div>
  );
};

export default LangSelect;
